// removed by extract-text-webpack-plugin
module.exports = {"default":"type__default___28cpO bg-white borderBottomWidth-1 borderColor-smoke borderColor-smoke--xd--hover borderStyle-solid borderWidth-0","defaultIsFocused":"type__defaultIsFocused___18AuL bg-white borderBottomWidth-1 borderColor-blue borderStyle-solid borderWidth-0"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-select/UnderlinedSelect/style/type.css
// module id = 232
// module chunks = 0 8